import { render, staticRenderFns } from "./PTableData.vue?vue&type=template&id=0d6434e2&scoped=true&"
import script from "./PTableData.vue?vue&type=script&lang=ts&"
export * from "./PTableData.vue?vue&type=script&lang=ts&"
import style0 from "./PTableData.vue?vue&type=style&index=0&id=0d6434e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6434e2",
  null
  
)

export default component.exports